import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isPushButtonsResponse = objectOf({
  push_buttons: arrayOf(
    objectOf({
      id: string,
      value: string,
      step_id: string,
    })
  ),
});
